export { default as volume0IconTemplate } from './volume0Icon.dot';
export { default as volume50IconTemplate } from './volume50Icon.dot';
export { default as volume100IconTemplate } from './volume100Icon.dot';
export { default as controlTemplate } from './control.dot';



// WEBPACK FOOTER //
// ./default-modules/ui/controls/volume/templates/index.ts